import { RootState } from '@/App/store';

export const selectResetPassword = (state: RootState) => state.resetPassword;
